'use strict';


// 外站連結
$(document).on('mouseenter touchstart', 'a[href]:not([target])', function () {
  if (this.getAttribute('href').match(/^(https?:)?\/\//) && !this.getAttribute('href').match(location.host)) {
    this.setAttribute('target', '_blank')
  }
})

$(document).on('click', 'a.disabled', function (event) {
  event.preventDefault()
  return false
})

function MotorsExpress() {
  if (!(document.documentMode)) {
    this.initWall()
  }
  this.init()
}

MotorsExpress.prototype.initWall = function () {

  const wall = new Freewall('.motors-list .motor-grids')
  let viewportW = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)

  wall.reset({
    selector: '.motor-grid',
    animate: true,
    cellW: function (width) {
      if (jQuery.isNumeric) {
        return width >= 768 ? 330 : width / 2
      } else {
        return width
      }
    },
    cellH: 'auto',
    onResize: function () {
      if (viewportW != Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) {
        viewportW = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        this.fitWidth()
      }
    }
  })
  wall.fitWidth()
  wall.container.find(' img').load(function () {
    wall.refresh()
  })
  window.motorsWall = this.motorsWall = wall
}
MotorsExpress.prototype.filterStyleTabs = function () {
  $('[data-f-style]').each(function (i, el) {
    let inClass = $('.motor-grid')
      .filter('[data-class*="' + this.filterConditions.classes + '"]')
      .filter('[data-style*="' + $(el).data('f-style') + '"]').length > 0
    $(this).toggleClass('disabled', !inClass)
  }.bind(this))
}

MotorsExpress.prototype.findMotors = function () {
  $('.motors-overview').toggleClass('hide', !!this.filterConditions.classes)
  $('select.filter-capacity').toggleClass('hide', !!this.filterConditions.classes)
  $('.motors-list').toggleClass('hide', !this.filterConditions.classes)
  $('select.filter-style').toggleClass('hide', !this.filterConditions.classes)

  if (this.filterConditions.classes === 'overview') {
    this.filterConditions.classes = null;
  }

  if (this.filterConditions.style === 'all') {
    this.filterConditions.style = null;
  }

  // 計算是否有風格的車可選
  $('select.filter-style option').each(function (i, el) {
    if (!el.value) { return }
    $(el).prop('disabled', $('.motors-list [data-class*="' + this.filterConditions.classes + '"][data-style*="' + el.value + '"]').length === 0)
  }.bind(this))

  $('.category-filter.style a[data-f-style]').each(function (i, el) {
    $(el).toggleClass('disabled', $('.motors-list [data-class*="' + this.filterConditions.classes + '"][data-style*="' + el.getAttribute('data-f-style') + '"]').length === 0);
  }.bind(this))

  // 目前選擇的風格
  $('.motor-class-menu a').removeClass('active').filter('[data-f-class=' + this.filterConditions.classes + ']').addClass('active')
  $('.category-filter.style a').removeClass('active').filter('[data-f-style=' + this.filterConditions.style + ']').addClass('active')

  if (!this.filterConditions.classes) {
    $('.motor-class-menu a').removeClass('active').first().addClass('active')
  } else {
    $('select.filter-class').prop('value', this.filterConditions.classes || 'overview')
  }
  if (!this.filterConditions.style) {
    $('.category-filter.style a').removeClass('active').first().addClass('active')
  } else {
    $('select.filter-style').prop('value', this.filterConditions.style || 'all')
  }

  if (!this.filterConditions.classes) {
    return false
  }

  let found = $('.motor-grid').toggleClass('filter-hide', true).toggleClass('found', false)
  found = !this.filterConditions.classes ? found : found.filter('[data-class*="' + this.filterConditions.classes + '"]')
  found = !this.filterConditions.style ? found : found.filter('[data-style*="' + this.filterConditions.style + '"]')
  found.toggleClass('filter-hide', false)
  found.toggleClass('found', true)
  this.motorsWall.filter('.found')
  this.filterStyleTabs()

  $('.motors-list').toggleClass('empty', found.length === 0)
}
MotorsExpress.prototype.init = function () {
  this.filterConditions = {
    'style': null,
    'classes': null
  }

  // function getTopnavOffset(){
  //   let style = window.getComputedStyle ? window.getComputedStyle($('.top-nav, .site-header')[0]) : {}
  //   return style.position == 'fixed' ? parseInt(style.height) : 0
  // }

  // $(document).on('click', '.category-filter.capacity a[href^="#"]', function(event){
  //   $('body, html').animate({
  //     scrollTop: $(event.currentTarget.getAttribute('href')).offset().top
  //   }, 200);
  // });

  $(document).on('change', 'select.filter-capacity', function (event) {
    // console.log(event.currentTarget.value)
    const dom = '#' + event.currentTarget.value
    // console.log($(dom).offset().top)
    // $('html, body').animate({
    //   scrollTop: $(dom).offset().top
    // }, 200)
    location.hash = dom
    // event.currentTarget.value = ''
  });

  $(document).on('change', 'select.filter-class', function (event) {
    this.filterConditions.classes = event.currentTarget.value
    this.findMotors()
  }.bind(this))

  $(document).on('change', 'select.filter-style', function (event) {
    this.filterConditions.style = event.currentTarget.value
    this.findMotors()
  }.bind(this))

  $(document).on('click', '.motor-class-menu a', function (event) {
    $(event.target).toggleClass('active', true).parent('li').siblings().find('a').toggleClass('active', false)
    $('.category-filter .style-all').click()
    $('.breadcrumbs span').text($(event.target).text())

    // 設定目前的種類
    this.filterConditions.classes = $(event.target).data('f-class')
    this.findMotors()
  }.bind(this))

  $(document).on('click', '.category-filter.style a:not(.disabled)', function (event) {
    $(this).toggleClass('active', true).parent('li').siblings().find('a').toggleClass('active', false)

    // 設定目前的風格
    this.filterConditions.style = $(event.target).data('f-style')
    this.findMotors()
  }.bind(this))
}

// $('html, body').on('scroll', function(){
//   $('body').toggleClass('fixed-nav', $('body').scrollTop() >= 90)
// });

$(document).on('scroll', function () {
  // 側邊社群按鈕
  const offset = $('.top-nav').outerHeight() - (document.body.scrollTop || (document.documentElement && document.documentElement.scrollTop))
  if (offset < (document.body.id == 'homePage' ? -200 : 0)) {
    $('.side_nav').fadeIn()
  } else {
    $('.side_nav').fadeOut()
  }

  // 頁面選單
  const el = document.querySelector('.category-filter')
  if (el == null) {
    return
  }
  el.style.transform = `translateY(${Math.max(0, document.documentElement.scrollTop - el.offsetTop)}px)`
  el.style.position = 'relative'
  el.style.zIndex = 101
})

$(function () {
  // 初始頁面載入時
  const express = new MotorsExpress()
  $('.side_nav').fadeOut()
})
